export default __webpack_public_path__ + "1c83f4fbb9b0aff6d054f891bc240403.png";